// Mock data for IWD Events Portfolio

export const events = [
  {
    id: 1,
    title: "Women with Disability Led Art Workshop",
    category: "Creative & Inclusive",
    duration: "60 minutes",
    format: "Onsite (Recommended)",
    groupSize: "Up to 50 participants",
    shortDescription: "A guided, beginner-friendly creative session delivered by women with disabilities, combining doodling or stone painting with meaningful inclusion learnings.",
    description: "This Creative Art Workshop helps participants tap into their creativity through simple, guided art activities - encouraging self-expression, mindfulness, and playful exploration. The session is led by artists with disabilities: a hard-of-hearing artist and a neurodivergent artist. The focus is on making creativity approachable while naturally building inclusion and comfort through interaction with facilitators with lived experience.",
    highlights: [
      "Doodling or stone painting options available",
      "Step-by-step guidance with freestyle creation time",
      "Inclusion cues through interaction with artists with disabilities",
      "Optional show and tell / desk gallery at the end"
    ],
    icon: "Palette",
    image: "https://customer-assets.emergentagent.com/job_iwd-showcase/artifacts/6j599qem_Doodline.png"
  },
  {
    id: 2,
    title: "Case Study-to-Action: Women at Work",
    category: "Interactive Learning",
    duration: "75 minutes",
    format: "Onsite",
    groupSize: "25-30 participants",
    shortDescription: "An interactive, outcome-driven Women's Day session where teams dissect real workplace scenarios and co-create practical solutions for inclusive hiring and promotions.",
    description: "Build awareness of how gender can create barriers in key career moments (recruitment and promotions). Help managers and HR move from assumptions to evidence-based decisions ('ask, don't assume'). Generate 2-3 actionable, workplace-ready solutions that teams can pilot after the session.",
    highlights: [
      "Participants break into groups and work on a realistic case study (Recruitment or Promotion)",
      "The case is revealed in stages (Exhibits/Envelopes) - similar to how decisions unfold in real life",
      "Groups identify where bias enters and where processes create unequal access",
      "Create solution packages with quick fixes and policy recommendations",
      "Converge on top priority actions to take forward"
    ],
    icon: "Users",
    image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=800"
  },
  {
    id: 3,
    title: "Foundational POSH Training",
    category: "Compliance & Culture",
    duration: "120-150 minutes",
    format: "Online / Onsite",
    groupSize: "Any number",
    shortDescription: "Build foundational understanding of the POSH framework with real-life case studies and practical takeaways.",
    description: "Sensitize employees, managers, HR teams, leadership, and ICC members on rights and responsibilities under the POSH Act, 2013. Strengthen respectful workplace culture by addressing power dynamics and workplace ethics.",
    highlights: [
      "Interactive presentation with case studies",
      "Covers online/virtual harassment contexts",
      "Role-specific responsibilities clarified",
      "Guided discussions on myths and grey areas"
    ],
    icon: "Shield",
    image: "https://customer-assets.emergentagent.com/job_iwd-showcase/artifacts/bpapxrpy_POSH%20Foundational%20Training.jpg"
  },
  {
    id: 4,
    title: "POSH Through a Disability Lens",
    category: "Advanced Inclusion",
    duration: "120-150 minutes",
    format: "Online / Onsite / Hybrid",
    groupSize: "Any number",
    shortDescription: "Advanced module strengthening POSH implementation with focus on disability-related vulnerabilities.",
    description: "Build awareness of heightened sexual harassment risks faced by persons with disabilities. Explore how consent, autonomy, and boundaries can be violated subtly, and review how existing POSH systems can be strengthened.",
    highlights: [
      "Intersectionality and vulnerability focus",
      "Scenario-based discussions",
      "Covers POSH Act 2013 and RPwD Act 2016",
      "Practical checklists and actionable takeaways"
    ],
    icon: "Eye",
    image: "https://customer-assets.emergentagent.com/job_iwd-showcase/artifacts/eair39hs_POSH%20Through%20a%20Disability%20Lens.png"
  },
  {
    id: 5,
    title: "Women's Day, Made Meaningful: A Team Reflection Workshop",
    category: "Reflective Experience",
    duration: "90-120 minutes",
    format: "Onsite (Hybrid adaptable)",
    groupSize: "25-30 participants",
    shortDescription: "A guided, mixed-gender leadership session where leaders reflect, share perspectives in small groups, and collectively agree on what the organization should focus on to make Women's Day meaningful.",
    description: "A structured conversation that helps people think together about what Women's Day should mean in your workplace, and what gender equity at work looks like in practice. Participants visualise, share in small groups, and converge on priority focus areas the organisation can take forward.",
    highlights: [
      "Individual reflection: Visualise an image/moment for prompts like Women's Day and Gender Equity",
      "Small-group sharing: Describe your image while others listen and ask clarifying questions",
      "Group prioritisation: Write down key elements for meaningful Women's Day and gender equity",
      "Cross-group review: Compare lists to notice common themes and gaps",
      "Convergence + ranking: Cluster themes and vote on most essential vs nice-to-have",
      "Closing reflection: Note one insight or focus area to carry forward"
    ],
    icon: "Heart",
    image: "https://customer-assets.emergentagent.com/job_iwd-showcase/artifacts/03bohjb7_A%20Tream%20Reflection%20Workshop.png"
  },
  {
    id: 6,
    title: "Panel Discussion: Many Roles, One Workplace - Creating Space for Every Woman",
    category: "Dialogue & Insights",
    duration: "60-75 minutes",
    format: "Virtual / Onsite / Hybrid",
    groupSize: "Any number",
    shortDescription: "A moderated panel featuring diverse voices to highlight intersectional perspectives and explore how workplaces can better support women across life stages and identities.",
    description: "International Women's Day is an opportunity to move beyond celebration and create meaningful dialogue on inclusion, equity, and belonging. Women's experiences are shaped by multiple factors - disability, neurodivergence, caregiving responsibilities, gender identity, workplace culture, and allyship. This panel surfaces these diverse realities and explores what organisations can do to create space for women in all their roles to thrive and be recognised equitably.",
    highlights: [
      "Diverse panelists reflecting women's varied lived experiences at work",
      "Themes: intersectionality, invisible labour, disclosure, systemic barriers, allyship in action",
      "Audience Q&A (live or chat-based) connecting to real workplace contexts",
      "Accessibility support: captioning, sign language, accessible formats"
    ],
    icon: "MessageCircle",
    image: "https://customer-assets.emergentagent.com/job_iwd-showcase/artifacts/7fvt8kk4_Panel%20Disucssion.png"
  },
  {
    id: 7,
    title: "Inclusion Spotlight: Performances",
    category: "Entertainment & Awareness",
    duration: "30-45 minutes",
    format: "Virtual / Onsite / Hybrid",
    groupSize: "Any number",
    shortDescription: "High-energy showcase featuring stand-up comedy, singing, or mixed performances by artists with disabilities.",
    description: "Create an engaging inclusion experience showcasing talent, creativity, and confidence of performers with disabilities. Build positive awareness and belonging through lived experience and representation.",
    highlights: [
      "Stand-up comedy acts",
      "Musical performances",
      "Mixed talent showcase options",
      "Professional hosting and emceeing"
    ],
    icon: "Mic",
    image: "https://customer-assets.emergentagent.com/job_iwd-showcase/artifacts/x5zul069_Inclusion%20Spotlight.jpg"
  },
  {
    id: 8,
    title: "Fireside Chat or Speaker Sessions with Women Leaders with Disability",
    category: "Authentic Stories",
    duration: "45-60 minutes",
    format: "Virtual / Onsite / Hybrid",
    groupSize: "Any number",
    shortDescription: "An authentic, relatable conversation with a person with disability covering resilience, work, and belonging.",
    description: "Moderated fireside chat bringing disability inclusion to life through guided conversation. Draws out real stories, turning points, and practical insights that help audiences connect emotionally and take away actionable learnings.",
    highlights: [
      "Guided personal journey narratives",
      "Workplace enablers and barriers discussed",
      "Live or chat-based Q&A",
      "Scalable format for large audiences"
    ],
    icon: "Flame",
    image: "https://customer-assets.emergentagent.com/job_iwd-showcase/artifacts/1nqm3196_Fireside%20Chat.png"
  },
  {
    id: 9,
    title: "Storytelling Show (Women and Allies)",
    category: "Engagement & Reflection",
    duration: "30-45 minutes",
    format: "Onsite",
    groupSize: "Any number",
    shortDescription: "A lively, performance-led storytelling show that helps employees learn through stories - sparking reflection on leadership, growth, allyship, and workplace culture.",
    description: "This is a lively, performance-led storytelling show designed for workplace audiences. The format blends facilitation, live narration and audience participation to create an experience that feels energising, thoughtful, and memorable. Instead of a one-way session, employees actively engage - reflecting and discussing insights together - making it ideal for Women's Day and allyship-focused themes.",
    highlights: [
      "Facilitator-led opening with energizer/icebreaker",
      "Live storytelling format",
      "Active audience participation and interaction",
      "Facilitated debrief after each segment"
    ],
    icon: "Mic",
    image: "https://customer-assets.emergentagent.com/job_iwd-showcase/artifacts/xrycuouu_Play.png"
  }
];

export const whyItWorks = [
  {
    id: 1,
    title: "Experiential Learning",
    description: "Move beyond passive awareness to active engagement through interactive workshops, case studies, and reflective exercises that create lasting behavioural change.",
    icon: "Lightbulb"
  },
  {
    id: 2,
    title: "Authentic Perspectives",
    description: "Sessions led by and featuring persons with disabilities bring genuine lived experiences that build empathy and break stereotypes effectively.",
    icon: "Users"
  },
  {
    id: 3,
    title: "Actionable Outcomes",
    description: "Every session is designed to generate practical, workplace-ready solutions that teams can implement immediately after the engagement.",
    icon: "Target"
  },
  {
    id: 4,
    title: "Intersectional Approach",
    description: "Address the unique challenges at the intersection of gender and disability, creating truly inclusive workplace cultures.",
    icon: "Layers"
  },
  {
    id: 5,
    title: "Flexible Formats",
    description: "Choose from onsite, virtual, or hybrid delivery options with accessibility supports built into every session.",
    icon: "Settings"
  },
  {
    id: 6,
    title: "Proven Impact",
    description: "Backed by v-shesh's award-winning track record in disability inclusion across 100+ leading organizations.",
    icon: "Award"
  }
];

export const aboutVshesh = {
  tagline: "Empowerment for Disability through Employment",
  description: "v-shesh is an award-winning impact enterprise specializing in disability inclusion. We create engaging, outcome-driven awareness sessions that combine experiential learning with authentic perspectives from people with disabilities.",
  highlights: [
    "National Award from Government of India for Empowerment of Persons with Disabilities",
    "Listed on Global Diversity Consultant list supported by The Economist",
    "Social Business of the Year - 10th Emerging India Awards",
    "NCPEDP Mphasis Universal Design Award",
    "Trusted by 100+ leading corporates including Amazon, IBM, JPMorgan, Flipkart"
  ]
};

export const contactInfo = {
  emails: [
    { name: "Raja", email: "raja@v-shesh.com" },
    { name: "Rashi", email: "rashi@v-shesh.com" },
    { name: "Shanthi", email: "shanthi.k@v-shesh.com" }
  ],
  phones: [
    { name: "Rajasekharan", phone: "+91 9600030311" },
    { name: "Rashi", phone: "+91 9643718789" }
  ]
};
